import Header from "../navigation/header";
import {
  StyleSheet,
  TouchableOpacity,
  Modal,
  Button,
  Switch,
  TextInput as TextInputRN,
  FlatList,
  Alert,
  ScrollView,
  SafeAreaView,
  ActivityIndicator,
  Dimensions,
} from "react-native";
import { useFocusEffect } from "@react-navigation/native";
import { Dropdown } from "react-native-element-dropdown";
import { DatePickerModal } from "react-native-paper-dates";

import { Text, View } from "../../components/Themed";
import { RootStackScreenProps } from "../../types";
import Icon from "react-native-vector-icons/AntDesign";
import IconEdit from "react-native-vector-icons/FontAwesome";
import IconEye from "react-native-vector-icons/Entypo";
import React, { useEffect, useState, useMemo, useRef } from "react";
import IconCross from "react-native-vector-icons/Entypo";
import AsyncStorage from "@react-native-async-storage/async-storage";
import AwesomeAlert from "react-native-awesome-alerts";
import { TextInput } from "react-native-paper";
import { baseUrl, postData } from "../../networking/api";
import { Provider as PaperProvider } from "react-native-paper";
import { Item } from "react-native-paper/lib/typescript/components/List/List";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import moment from "moment";
import { saveAs } from "file-saver";

export default function AlertScreen({ navigation }) {
  const [isLoadingSync, setIsLoadingSync] = useState(false);

  const [isVisible, setIsVisible] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [OmegeDeviceIds, setOmegeDeviceId] = useState();
  const [isAdd, setisAdd] = useState(false);
  var [counter, setCounter] = useState(1);
  const [sort, setsort] = useState(0);
  const [editpopup, setEditPopup] = useState(false);
  const [popid, setpopid] = useState("");
  const [popindex, setpopindex] = useState("");
  const [projectId, setProjectId] = useState("");
  const [projectCodeID, setProjectCode] = useState("");

  const [OmegaIdData, setOmegaIdData] = useState([]);
  const [OmegavalueId, setOmegaValueiD] = useState("");
  const [OmegaId, setOmegaId] = useState("");

  const [OmegaIdValue, setOmegaIdValue] = useState(null);
  const [OmegaError, setOmegaError] = useState("");
  const [isFocus, setIsFocus] = useState(false);

  const [alertTypeValue, setAlertTypeValue] = useState("");

  var idProject = useSelector((state) => state.idUpdating);
  var projectCodeId = useSelector((state) => state.projectCodeId);

  const [showAlert, setAlert] = useState(false);
  const [isOmegeDeviceNameValid, setOmegeDeviceNameDataValid] = useState(false);
  const [isOmegeDeviceNameEntered, setOmegeDeviceNameDataEntered] =
    useState(false);
  const [OmegeDeviceName, setOmegeDeviceNameData] = useState([]);
  const [OmegeDeviceByName, setOmegeDeviceByName] = useState("");
  const [error, setError] = useState("");
  const textOmegeDeviceName = useRef("");
  const [OmegeDeviceLength, setOmegeDeviceLength] = useState(0);
  const [searchData, setSearch] = useState("");
  const [filterData, setFilteredDataSource] = useState([]);
  const [alertData, setAlertData] = useState([
    {
      name: "All",
      value: "",
    },
    {
      name: "General Error",
      value: "general_error",
    },
    {
      name: "Reset Reason",
      value: "unit_reset",
    },
    {
      name: "Low Battery",
      value: "low_battery",
    },
    {
      name: "Critical Low Battery",
      value: "critical_low_battery",
    },
    {
      name: "Modem Error",
      value: "modem_error",
    },
    {
      name: "SIM Error",
      value: "sim_error",
    },
    {
      name: "RSSI + Cellular provider",
      value: "cellular_provider_rssi",
    },
    {
      name: "Start FOTA",
      value: "start_fota",
    },
    {
      name: "End FOTA",
      value: "end_fota",
    },
    {
      name: "Modem Connect",
      value: "modem_connect",
    },
    {
      name: "Modem Disconnect",
      value: "modem_disconnect",
    },
    {
      name: "Configuration Error",
      value: "configuration_error",
    },
    {
      name: "Unit Started",
      value: "unit_started",
    },
    {
      name: "Program enqueue",
      value: "program_enqueue",
    },
    {
      name: "Program dequeued",
      value: "program_dequeued",
    },
    {
      name: "Capacitor failure",
      value: "capacitor_failure",
    },
    {
      name: "Battery check",
      value: "battery_voltage",
    },
    {
      name: "Analog Error28",
      value: "analog_error",
    },
    {
      name: "Unit disconnect from the server",
      value: "unit_started",
    },
    {
      name: "Modbus Error",
      value: "modbus_error",
    },
    {
      name: "Open Valve",
      value: "valve_open",
    },
    {
      name: "Close Valve",
      value: "valve_close",
    },
    {
      name: "Open Fertigation",
      value: "fertigation_open",
    },
    {
      name: "Close Fertigation",
      value: "fertigation_close",
    },
  ]);

  const [isPressAlert, setIsPressAlert] = useState(false);
  const [isPressOmega, setIsPressOmega] = useState(false);

  const [FromDateError, setFromDateError] = useState("");
  const [ToDateError, setToDateError] = useState("");

  const optionsPerPage = [10, 25, 50, 100];

  const [page, setPage] = React.useState(0);
  const [itemsPerPage, setItemsPerPage] = React.useState(optionsPerPage[0]);
  const from = page * itemsPerPage;
  const to = Math.min((page + 1) * itemsPerPage, OmegeDeviceLength);
  React.useEffect(() => {
    setIsPressOmega(true);
    setPage(0);
    setpopindex("");
    setEditPopup(false);
    setpopid("");
  }, [itemsPerPage]);
  const isCreatable = () => {
    setIsVisible(true);
    setisAdd(true);
  };

  var alpha_pattern = new RegExp(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/);

  const [FromDate, setFromDate] = React.useState<Date | undefined>(new Date());
  const [FromOpen, setFromOpen] = React.useState(false);

  const onDismissFrom = React.useCallback(() => {
    setFromOpen(false);
  }, [setFromOpen]);

  const onConfirmFrom = React.useCallback(
    (params: { date: React.SetStateAction<Date | undefined> }) => {
      setFromOpen(false);
      setFromDateError("");
      setFromDate(params.date);
    },
    [setFromOpen, setFromDate],
  );

  const [ToDate, setToDate] = React.useState<Date | undefined>(new Date());
  const [ToOpen, setToOpen] = React.useState(false);

  const onDismissTo = React.useCallback(() => {
    setToOpen(false);
  }, [setToOpen]);

  const onConfirmTo = React.useCallback(
    (params: { date: React.SetStateAction<Date | undefined> }) => {
      setToOpen(false);
      setToDateError("");
      setToDate(params.date);
    },
    [setToOpen, setToDate],
  );

  const dropdownRefOmegaiD = useRef();
  const closeMenu = () => {
    dropdownRefOmegaiD.current.close();
  };

  useEffect(() => {
    window.addEventListener("scroll", closeMenu);
    return () => window.removeEventListener("scroll", closeMenu);
  }, []);

  useFocusEffect(
    React.useCallback(() => {
      getAdminData();
      setIsPressOmega(true);
      searchFilterFunction("");
    }, [projectCodeId, projectCodeID]),
  );

  const getAdminData = async () => {
    let jsonValue = await AsyncStorage.getItem("userData");
    let proCodeId = await AsyncStorage.getItem("projectCode");
    let proCode = JSON.parse(proCodeId);
    setProjectCode(proCode);

    let projValue = await AsyncStorage.getItem("projectData");

    if (projValue != null) {
      setProjectId(projValue);
      getOmegaDependentByProjectId(projValue);
    } else if (jsonValue != null) {
      var userDetailsresponse = JSON.parse(jsonValue);

      setProjectId(userDetailsresponse.project_selected);
      getOmegaDependentByProjectId(userDetailsresponse.project_selected);
    }
  };

  const getDownloadExcel = async () => {
    try {
      const fromD = moment(FromDate).format("YYYY-MM-DDT00:00:19+00:00");
      const toD = moment(ToDate).format("YYYY-MM-DDT23:59:00+00:00");
      const omegaIds = OmegaId === "" ? 0 : OmegaId;
      const alertTypes = alertTypeValue === "" ? 0 : alertTypeValue;

      const farmerTokenData = await AsyncStorage.getItem("farmerToken");
      const userToken = await AsyncStorage.getItem("userToken");
      const token = userToken ? userToken : farmerTokenData || "";

      const response = await fetch(
        `${baseUrl}masters/exportSystemLogs/${fromD}/${toD}/${projectCodeID}/${omegaIds}/${alertTypes}`,
        {
          method: "GET",
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            Authorization: token,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Export failed with status ${response.status}`);
      }

      const excelData = await response.blob();
      saveAs(excelData, "system_logs.xlsx");
    } catch (error) {
      console.error("getDownloadExcel error", error);
    }

    return false;
  };

  const getOmegaDependentByProjectId = async (projectID) => {
    setIsLoading(true);
    try {
      var OmegaIdData = JSON.stringify({
        column: "project_id",
        value: projectID,
        module: "devices_master",
      });
      const OmegaIdList = await postData(
        OmegaIdData,
        "masters/getDependentMasterList",
      );
      setIsLoading(false);
      var code = OmegaIdList.code;
      if (code == 1) {
        var mergeData = OmegaIdList.data;
        mergeData.unshift({
          id: 0,
          project_id: projectId,
          omega_id: "",
          device_name: "All",
          lat: "",
          long: "",
          active: 1,
        });
        setOmegaIdData(mergeData);
        setOmegaIdValue("All");
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const renderOmegaIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {item.id === OmegavalueId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };
  const renderAlertTypeList = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.name}</Text>}
        {isAdd == false && <Text style={styles.textItem}>{item.name}</Text>}
        {item.value === alertTypeValue && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };
  const searchFilterFunction = (text) => {
    if (text) {
      const newData = OmegeDeviceName.filter(function (item) {
        const itemData = item.device_name
          ? item.device_name.toUpperCase()
          : "".toUpperCase();
        const textData = text.toUpperCase();
        return itemData.indexOf(textData) > -1;
      });
      setFilteredDataSource(newData);
      setSearch(text);
      setPage(0);
    } else {
      setFilteredDataSource(OmegeDeviceName);
      setSearch(text);
      setPage(0);
    }
  };
  var counter = 1;
  const customStyles = {
    rows: {
      style: {
        minHeight: "30px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        backgroundColor: "#319ef0a3",
        minHeight: "40px",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    headCells: {
      style: {
        justifyContent: "center",
        minHeight: "20px",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        justifyContent: "center",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          fontSize: 16,
          fontWeight: "400",
          textTransform: "Capitalize",
        },
      },
    },
  };
  const caseInsensitiveSort = (rowA, rowB) => {
    const a = rowA.OmegeDevice.toLowerCase();
    const b = rowB.OmegeDevice.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  const columnsAlert = [
    {
      name: "Alert Type",
      selector: (row) => row.index,
    },
    {
      name: "Device",
      selector: (row) => row.index,
    },
    {
      name: "Project",
      selector: (row) => row.OmegeDevice,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Timestamp",
      selector: (row) => row.OmegeDevice,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Status",
      cell: (item, index) => (
        <Switch
          trackColor={{ false: "#767577", true: "#1DA1F2" }}
          thumbColor={item.active == 1 ? "#fff" : "#f4f3f4"}
          activeThumbColor="#fff"
          onValueChange={() => {
            setEditPopup(true);
            setpopid(item.id);
            setpopindex(index);
          }}
          value={item.active == 1 ? true : false}
        />
      ),
    },
    {
      name: "Alerts",
      selector: (row) => row.OmegeDevice,
    },
  ];
  const columnsOmega = [
    {
      name: "Date",
      selector: (row) => {
        return `${row.datetimelocal.split("T")[0]} ${row.datetimelocal.split("T")[1].split("+")[0]}`;
      },
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },

    {
      name: "Omega name",
      selector: (row) => row.unit_name,
    },
    {
      name: "Event",
      selector: (row) => row.line,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },

    {
      name: "Data",
      selector: (row) => row.key + ":" + row.value,
    },
  ];

  useFocusEffect(
    React.useCallback(() => {
      getOmegaDeviceData(OmegaId, alertTypeValue);
    }, [FromDate, ToDate]),
  );

  const getOmegaDeviceData = async (omegaId, alertValue) => {
    var fromD = moment(FromDate).format("YYYY-MM-DD");
    var toD = moment(ToDate).format("YYYY-MM-DD");
    let proCodeId = await AsyncStorage.getItem("projectCode");
    let proCode = JSON.parse(proCodeId);
    setIsLoadingSync(true);
    try {
      var OmegeDeviceData = JSON.stringify({
        from_date: fromD,
        to_date: toD,
        unit_id: omegaId,
        project_id: proCode,
        alert_type: alertValue == null ? alertTypeValue : alertValue,
      });

      const OmegeDeviceNameResponse = await postData(
        OmegeDeviceData,
        "masters/getLogsSystem",
      );
      setIsLoadingSync(false);
      var code = OmegeDeviceNameResponse.code;
      if (code == 1) {
        setIsPressOmega(true);
        setOmegeDeviceNameData(OmegeDeviceNameResponse.data);
      } else {
        setIsLoadingSync(false);
        setOmegeDeviceNameData([]);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const screenwidth = Dimensions.get("window").width;
  const isMobile = screenwidth < 768;
  return (
    <View
      style={
        isMobile
          ? {
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              paddingTop: 75,
              marginTop: 50,
              height: "100%",
            }
          : styles.container
      }
    >
      <View
        style={
          isMobile
            ? { flexDirection: "row", width: "100%", marginTop: "10%" }
            : { flexDirection: "row", width: "100%", marginTop: "10%" }
        }
      >
        <View
          style={
            isMobile ? { marginLeft: 10, paddingTop: -20 } : { margin: 10 }
          }
        >
          <Text
            style={
              isMobile
                ? [styles.lableText, { paddingTop: -20 }]
                : styles.lableText
            }
          >
            Alerts{" "}
          </Text>
        </View>
      </View>
      <View
        style={
          isMobile
            ? {
                flexDirection: "row",
                width: "100%",
                marginTop: "5%",
                marginLeft: 20,
              }
            : {
                flexDirection: "row",
                width: "100%",
                marginTop: "5%",
                marginLeft: 20,
              }
        }
      >
        <View
          style={isMobile ? { width: "38%", marginLeft: 10 } : { width: "17%" }}
        >
          <Text>From Date</Text>
          <View style={{ flexDirection: "column", marginTop: 7 }}>
            <Text style={styles.input} onPress={() => setFromOpen(true)}>
              {isMobile
                ? moment(FromDate).format("DD/MM/YY")
                : moment(FromDate).format("DD/MM/YYYY")}
            </Text>
            <Text style={styles.error_text}>{FromDateError}</Text>
          </View>
        </View>

        <DatePickerModal
          locale="en"
          mode="single"
          visible={FromOpen}
          onDismiss={onDismissFrom}
          date={FromDate}
          onConfirm={onConfirmFrom}
          validRange={{
            endDate: new Date(),
          }}
          label="Select date"
          closeIcon="close"
          calendarIcon="calendar"
        />
        <View
          style={
            isMobile ? { width: "38%", marginLeft: -20 } : { width: "17%" }
          }
        >
          <Text>To Date</Text>
          <View style={{ flexDirection: "column", marginTop: 7 }}>
            <Text style={styles.input} onPress={() => setToOpen(true)}>
              {isMobile
                ? moment(ToDate).format("DD/MM/YY")
                : moment(ToDate).format("DD/MM/YYYY")}
            </Text>
            <Text style={styles.error_text}>{ToDateError}</Text>
          </View>
        </View>

        <DatePickerModal
          locale="en"
          mode="single"
          visible={ToOpen}
          onDismiss={onDismissTo}
          date={ToDate}
          onConfirm={onConfirmTo}
          validRange={{
            endDate: new Date(),
          }}
          label="Select date"
          closeIcon="close"
          calendarIcon="calendar"
        />
        <View
          style={
            isMobile ? { width: "35%", marginLeft: -20 } : { width: "17%" }
          }
        >
          <Text>Select Event</Text>
          <Dropdown
            ref={dropdownRefOmegaiD}
            style={styles.dropdown}
            placeholderStyle={styles.placeholderStyle}
            selectedTextStyle={styles.selectedTextStyle}
            inputSearchStyle={styles.inputSearchStyle}
            iconStyle={styles.iconStyle}
            data={alertData}
            search
            maxHeight={300}
            labelField="name"
            valueField="value"
            placeholder={alertTypeValue ? alertTypeValue : "Event"}
            searchPlaceholder="Search..."
            value={alertTypeValue}
            onChange={(item) => {
              setAlertTypeValue(item.value);
              getOmegaDeviceData(OmegaId, item.value);
            }}
            renderItem={renderAlertTypeList}
          />
        </View>

        {!isMobile && (
          <View style={{ width: "17%", marginLeft: 10 }}>
            <Text>Select Omega</Text>
            <Dropdown
              ref={dropdownRefOmegaiD}
              style={styles.dropdown}
              placeholderStyle={styles.placeholderStyle}
              selectedTextStyle={styles.selectedTextStyle}
              inputSearchStyle={styles.inputSearchStyle}
              iconStyle={styles.iconStyle}
              data={OmegaIdData}
              search
              maxHeight={300}
              labelField="device_name"
              valueField="device_name"
              placeholder={!isFocus ? "Omega Device" : "...."}
              searchPlaceholder="Search..."
              value={OmegaIdValue}
              onChange={(item) => {
                setOmegaIdValue(item.device_name);
                setOmegaValueiD(item.id);
                if (FromDate === undefined && ToDate === undefined) {
                  setFromDateError("Please select from data");
                  setToDateError("Please select to date");
                } else {
                  setOmegaId(item.omega_id);
                  getOmegaDeviceData(item.omega_id, alertTypeValue);
                  setFromDateError("");
                  setToDateError("");
                }
              }}
              renderItem={renderOmegaIdListItems}
            />
          </View>
        )}

        {!isMobile && (
          <View
            style={
              isMobile
                ? { marginTop: "30%", flex: 1, marginLeft: "10%" }
                : { alignItems: "flex-end", margin: 27, flex: 1 }
            }
          >
            {OmegeDeviceName.length > 0 && (
              <TouchableOpacity
                style={
                  isMobile
                    ? {
                        alignItems: "center",
                        backgroundColor: "#747474",
                        padding: 10,
                        borderWidth: 1,
                        borderColor: "#747474",
                        width: "70%",
                        borderRadius: 10,
                      }
                    : styles.alertBtn
                }
                onPress={() => {
                  getDownloadExcel();
                }}
              >
                <Text style={styles.btnText}>
                  <Icon name="exclefile1" size={15} color="#fff" /> Download
                </Text>
              </TouchableOpacity>
            )}
          </View>
        )}
      </View>
      {isMobile && (
        <View
          style={
            isMobile
              ? {
                  flexDirection: "row",
                  width: "100%",
                  marginLeft: 40,
                }
              : null
          }
        >
          <View
            style={
              isMobile ? { width: "40%" } : { width: "17%", marginLeft: 10 }
            }
          >
            <Text>Select Omega</Text>
            <Dropdown
              ref={dropdownRefOmegaiD}
              style={styles.dropdown}
              placeholderStyle={styles.placeholderStyle}
              selectedTextStyle={styles.selectedTextStyle}
              inputSearchStyle={styles.inputSearchStyle}
              iconStyle={styles.iconStyle}
              data={OmegaIdData}
              search
              maxHeight={300}
              labelField="device_name"
              valueField="device_name"
              placeholder={!isFocus ? "Omega Device" : "...."}
              searchPlaceholder="Search..."
              value={OmegaIdValue}
              onChange={(item) => {
                setOmegaIdValue(item.device_name);
                setOmegaValueiD(item.id);
                if (FromDate === undefined && ToDate === undefined) {
                  setFromDateError("Please select from data");
                  setToDateError("Please select to date");
                } else {
                  setOmegaId(item.omega_id);
                  getOmegaDeviceData(item.omega_id, alertTypeValue);
                  setFromDateError("");
                  setToDateError("");
                }
              }}
              renderItem={renderOmegaIdListItems}
            />
          </View>

          <View
            style={
              isMobile
                ? { marginTop: 25, marginLeft: "18%" }
                : { alignItems: "flex-end", margin: 27, flex: 1 }
            }
          >
            {OmegeDeviceName.length > 0 && (
              <TouchableOpacity
                style={
                  isMobile
                    ? {
                        alignItems: "center",
                        backgroundColor: "#747474",
                        padding: 10,
                        borderWidth: 1,
                        borderColor: "#747474",
                        width: "100%",
                        borderRadius: 10,
                      }
                    : styles.alertBtn
                }
                onPress={() => {
                  getDownloadExcel();
                }}
              >
                <Text style={styles.btnText}>
                  <Icon name="exclefile1" size={15} color="#fff" /> Download
                </Text>
              </TouchableOpacity>
            )}
          </View>
        </View>
      )}

      <View style={[styles.card, { flexGrow: 1 }]}>
        <View
          style={[
            styles.shadowProp,
            {
              backgroundColor: "white",
            },
          ]}
        >
          <View
            style={{
              width: "100%",
              backgroundColor: "#F6F9F9",
            }}
          >
            <View style={{}}>
              <View>
                {isPressAlert == true && (
                  <DataTable
                    columns={columnsAlert}
                    data={filterData}
                    customStyles={customStyles}
                    pagination
                    defaultSortFieldId={"OmegeDevice"}
                    defaultSortAsc={true}
                  />
                )}
                {isLoadingSync ? (
                  <ActivityIndicator
                    color="#1DA1F2"
                    visible={isLoadingSync}
                    textContent={"Loading..."}
                    size={100}
                  />
                ) : OmegeDeviceName.length > 0 ? (
                  <DataTable
                    columns={columnsOmega}
                    data={OmegeDeviceName}
                    customStyles={customStyles}
                    pagination
                    defaultSortFieldId={"OmegeDevice"}
                    defaultSortAsc={true}
                  />
                ) : (
                  <View
                    style={{
                      justifyContent: "center",
                      backgroundColor: "#fff",
                    }}
                  >
                    <Text
                      style={[
                        styles.emptyListStyle,
                        {
                          alignSelf: "center",
                          marginTop: 20,
                          color: "#000000",
                        },
                      ]}
                    >
                      No Program data Found{" "}
                    </Text>
                  </View>
                )}
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    marginTop: "2%",
    height: "100%",
  },
  itemStyle: {
    padding: 10,
  },
  textInputStyle: {
    height: 35,
    borderWidth: 2,
    paddingLeft: 20,
    borderRadius: 5,
    borderColor: "#319ef0",
    backgroundColor: "#FFFFFF",
    width: "40%",
    fontWeight: "400",
  },
  tableHead: {
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "700",
    color: "#000000",
  },

  containeralt: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 10,
    borderWidth: 1,
    height: 300,
    margin: "auto",
    padding: 30,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "30%",
  },
  contanerSwitch: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 5,
    alignSelf: "center",
    borderWidth: 1,
    height: "25%",
    margin: "auto",
    padding: 10,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "30%",
  },
  tableHeader: {
    color: "#000",
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "400",
  },
  input: {
    borderColor: "#c3c3c3",
    width: "70%",
    borderWidth: 1,
    borderRadius: 4,
    marginRight: 10,
    padding: 10,
    marginBottom: 6,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  alertBtn: {
    alignItems: "center",
    backgroundColor: "#747474",
    padding: 10,
    borderWidth: 1,
    borderColor: "#747474",
    width: "50%",
    borderRadius: 10,
  },
  alertBtnAfter: {
    alignItems: "center",
    backgroundColor: "#fff",
    padding: 10,
    borderWidth: 1,
    borderColor: "#747474",
    width: "33%",
    borderRadius: 10,
  },
  saveBtn: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
    marginRight: 10,
  },
  btnText: {
    color: "#fff",
    fontWeight: "600",
  },
  btnTextAfter: {
    color: "#000",
    fontWeight: "600",
  },
  card: {
    width: "70%",
    flex: 1,
    marginVertical: 10,
  },
  shadowProp: {
    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 15,
  },
  error_text: {
    color: "red",
    fontSize: 14,
    fontWeight: "600",
    width: "70%",
    marginLeft: 0,
    marginBottom: 10,
  },

  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    color: "#2e78b7",
  },

  dropdown: {
    borderColor: "#c3c3c3",
    width: "80%",
    borderWidth: 1,
    borderRadius: 2,
    height: 40,
    marginLeft: 0,
    outlineStyle: "none",
    padding: 10,
    marginTop: 7,
    marginBottom: 5,
  },
  icon: {
    marginRight: 5,
  },
  item: {
    padding: 9,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textItem: {
    flex: 1,
    fontSize: 16,
  },
  placeholderStyle: {
    fontSize: 16,
  },
  selectedTextStyle: {
    fontSize: 16,
  },
  iconStyle: {
    width: 20,
    height: 20,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,
    outlineStyle: "none",
  },
  lableText: {
    color: "#484848",
    fontWeight: "700",
    marginTop: 18,
  },
  emptyListStyle: {
    padding: 20,
    fontSize: 20,
    textAlign: "center",
  },
});
